import { ForwardedRef, forwardRef } from 'react';
import { Typography } from '@material-ui/core';

import { useCodeStyles } from './Typography.styles';
import { TypographyProps } from './Typography.props';

/**
 * Typography.Code component
 * @returns {JSX.Element}
 */
export const Code = forwardRef(
  ({ className = '', ...props }: TypographyProps, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const styles = useCodeStyles();

    return <Typography classes={styles} className={className} {...props} {...{ ref }} />;
  },
);

Code.displayName = 'Typography.Code';
